<div class="text-center">
  <small class="pr-1"><i class="fas fa-window-maximize"></i></small>
  <div *ngFor="let button of modals" class="badge alert-{{button.class}}" (click)="showModal(button.modal)"
    [popoverFade]="button.modal.title"><i class="{{ button.icon }}"></i></div>
</div>
